import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const UniversityUsers = () => {
  const navigate=useNavigate()
  const [users, setUsers] = useState([]); // Users from API
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 5;

  // Fetch users from API
//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const response = await fetch("https://api.example.com/users"); // replace with your API endpoint
//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     };

//     fetchUsers();
//   }, []);
useEffect(() => {
  setUsers([
    { id: 1, name: "Hassan Ali", email: "hassan@example.com", role: "Admin", department: "IT" },
    { id: 2, name: "Sara Khan", email: "sara@example.com", role: "Manager", department: "HR" },
    { id: 3, name: "Ali Raza", email: "ali@example.com", role: "Developer", department: "Engineering" },
    { id: 4, name: "Amir Shah", email: "amir@example.com", role: "Designer", department: "Design" },
    { id: 5, name: "Ayesha Malik", email: "ayesha@example.com", role: "Analyst", department: "Finance" },
    { id: 6, name: "Bilal Khan", email: "bilal@example.com", role: "Support", department: "Customer Service" },
    { id: 7, name: "Farah Iqbal", email: "farah@example.com", role: "HR", department: "HR" },
    { id: 8, name: "Zain Ali", email: "zain@example.com", role: "Developer", department: "Engineering" },
    { id: 9, name: "Hina Shah", email: "hina@example.com", role: "Admin", department: "IT" },
    { id: 10, name: "Usman Riaz", email: "usman@example.com", role: "Manager", department: "Operations" },
  ]);
}, []);

  // Filter users based on search term
  const filteredUsers = users.filter(
    (user) =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="p-6">
      {/* Heading */}
      <h1 className="text-2xl font-bold mb-2">Users List</h1>
      <p className="text-gray-600 mb-4">
        Manage all the users in your system. You can add, edit, or remove users.
      </p>

      {/* Search and Add User */}
      <div className="flex justify-between items-center mb-4">
        {/* Search Input */}
        <input
          type="text"
          placeholder="Search by name or email..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1); // reset to first page on search
          }}
          className="border border-gray-300 rounded px-3 py-2 w-full max-w-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        {/* Add User Button */}
        <button onClick={()=>navigate('/marketplace/university/users/add')} className="bg-blue-500 text-white px-4 py-2 rounded ml-4 hover:bg-blue-600 transition">
          Add User
        </button>
      </div>

      {/* Users Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-2 px-4 border-b text-left">ID</th>
              <th className="py-2 px-4 border-b text-left">Name</th>
              <th className="py-2 px-4 border-b text-left">Email</th>
              <th className="py-2 px-4 border-b text-left">Role</th>
              <th className="py-2 px-4 border-b text-left">Department</th>
              <th className="py-2 px-4 border-b text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.length > 0 ? (
              currentUsers.map((user) => (
                <tr key={user.id} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border-b">{user.id}</td>
                  <td className="py-2 px-4 border-b">{user.name}</td>
                  <td className="py-2 px-4 border-b">{user.email}</td>
                  <td className="py-2 px-4 border-b">{user.role}</td>
                  <td className="py-2 px-4 border-b">{user.department}</td>
                  <td className="py-2 px-4 border-b">
                    <button className="text-blue-500 hover:underline mr-2">Edit</button>
                    <button className="text-red-500 hover:underline">Delete</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="py-4 px-4 border-b text-center" colSpan="6">
                  No users found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center mt-4 space-x-2">
        {Array.from({ length: totalPages }, (_, idx) => (
          <button
            key={idx + 1}
            onClick={() => paginate(idx + 1)}
            className={`px-3 py-1 rounded border ${
              currentPage === idx + 1
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            {idx + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default UniversityUsers;
